/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpServiceId } from '@squiz/dxp-auth';

/**
 * The data IDs used in the Setting list component.
 */
export const SETTING_LIST_DATA_IDS = {
  actionCreateSettingCancel: `Create setting: Cancel action`,
  actionCreateSettingConfirm: `Create setting: Confirm action`,
  actionCreateSettingNext: `Create setting: Next action`,
  actionCreateSettingSuccess: `Create setting: Success message`,
  actionDeleteSetting: `Accordion: Delete setting`,
  actionDeleteSettingConfirm: `Delete setting: Confirm action`,
  actionDeleteSettingSuccess: `Delete setting: Success message`,
  actionEditSettingCancel: `Edit setting: Cancel action`,
  actionEditSettingSave: `Edit setting: Save action`,
  actionEditSettingSuccess: `Edit setting: Success message`,
  createSettingButton: `Button: Create setting`,
  editSettingButton: `Button: Edit setting`,
  emptyState: `Service settings: No settings`,
  settingCreatedToast: `Toast: Setting created`,
  settingCreateForm: `Setting creation: Step One - Create setting`,
  settingEditForm: `Setting edit: Update/delete setting`,
  settingKey: `Form Field: Setting key`,
  settingUpdatedToast: `Toast: Setting updated`,
  settingValueForm: `Setting creation: Step Two - Populate setting value`,
};

/**
 * The form field ids used in the Setting list component.
 */
export const SETTING_LIST_FORM_IDS = {
  settingKey: `setting-key`,
};

/**
 * The DXP service ID used for global settings.
 */
export const GLOBAL_SERVICE_ID = DxpServiceId.dxpConsole;
